import { useState, useEffect } from 'react';
import { acceptInvite } from '../api';
import { setOrgId, isAuthenticated } from '../auth';

export default function AcceptInvite({ token, onAccepted, onGoToLogin, onGoToSignup }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [accepted, setAccepted] = useState(false);

  const handle = async () => {
    if (!isAuthenticated()) {
      // Save token to localStorage and redirect to login/signup
      localStorage.setItem('pendingInviteToken', token);
      onGoToSignup();
      return;
    }
    setLoading(true);
    try {
      const res = await acceptInvite(token);
      setOrgId(res.org.orgId);
      setAccepted(true);
      setTimeout(() => onAccepted(res.org), 2000);
    } catch (err) {
      setError(err.message || 'Failed to accept invite');
    } finally { setLoading(false); }
  };

  useEffect(() => { if (token) handle(); }, []);

  return (
    <div className="login-page">
      <div className="login-box" style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>{accepted ? '🎉' : loading ? '⏳' : '✉️'}</div>
        <h2 style={{ color: 'var(--navy)', marginBottom: 8 }}>
          {accepted ? 'You\'re in!' : loading ? 'Accepting invite…' : 'Team Invitation'}
        </h2>
        {error && <div className="alert alert-error" style={{ textAlign: 'left' }}>{error}</div>}
        {accepted && <p style={{ color: 'var(--muted)' }}>Redirecting to your dashboard…</p>}
        {!loading && !accepted && !error && (
          <div>
            <p style={{ color: 'var(--muted)', marginBottom: 20 }}>You need to sign in or create an account to accept this invitation.</p>
            <div style={{ display: 'flex', gap: 10, justifyContent: 'center' }}>
              <button className="btn btn-primary" onClick={onGoToSignup}>Create Account</button>
              <button className="btn btn-ghost" onClick={onGoToLogin}>Sign In</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
